import {SvgSexOne, SvgSexCondom, SvgSexOneLearnMore , SvgSexOneA, SvgSexOneBLearnMore} from "components/Images/sex";

const sexOne = [
    {
        id: 'sex-1',
        type: 'question',
        text: "<p>After watching a few bands, Amari leans closer to Jamie and whispers for them to head back to the tent. Once there, they begin to make out. After a few minutes of passionate kissing, things start to heat up. With most of their clothes off, Amari moves to pull off Jamie’s underwear and says, “Is this ok? I’ve been wanting this for a while.”</p><p>How does the night proceed?</p>",
        backgroundImage: SvgSexOne,
        options: [
          {
            id: 'sex-1-option-1',
            text: 'Jamie responds, “Me too! I’ve brought condoms.”',
            icon: SvgSexCondom,
            iconType: 'svg',
            iconBackground: '#c9e9ff',
            nextStepId: 'sex-1-learnmore'
          },
          {
            id: 'sex-1-option-2',
            text: 'Jamie responds, “I’m not sure. I really want to take our relationship to the next level, but we haven’t really talked about it. Can we talk first?”',
            icon: '💬',
            iconBackground:'#cbd8f9',
            nextStepId: 'sex-2-learnmore',
  
          },
          {
            id: 'sex-1-option-3',
            text: 'Jamie responds, “I just like making out. I’m not ready for sex.”',
            icon: '😯',
            iconBackground:'#fbe9b6',
            nextStepId: 'sex-3-learnmore',
          }
        ]
      },
      {
        id: 'sex-1-learnmore',
        type: 'learnmore',
        text: '<p>Both Jamie and Amari have both consented to having sex with an enthusiastic ‘YES’.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>An enthusiastic ‘YES’ is essential when it comes to any sexual activity, whether with a longer-term partner or hooking up with a new one. Your partner's body language and facial expression can also help you know if they're giving consent.</p>"
        },
        nextStepId: 'sex-1a',
      },
      {
        id: 'sex-1a',
        type: 'question',
        text: "<p>Amari takes the condom from Jamie, removes the rest of their clothes and…</p>",
        backgroundImage:  SvgSexOneA,
        options: [
          {
            id: 'sex-1a-option-1',
            text: 'Starts to open the condom package, checking the expiry date and that there are no tears or holes in the package before opening.',
            icon: SvgSexCondom,
            iconType: 'svg',
            iconBackground: '#c9e9ff',
            nextStepId: 'sex-1a-learnmore'
          },
          {
            id: 'sex-1a-option-2',
            text: 'Tosses the condom to the side and says “We don’t need to use protection. I’m not worried about us getting pregnant.”',
            icon: '😤',
            iconBackground:'#fbe9b6',
            nextStepId: 'sex-1b-learnmore',
    
          }
        ]
      },
      {
        id: 'sex-1a-learnmore',
        type: 'learnmore',
        text: '<p>Jamie and Amari both agree that using a condom is the best way to reduce their risk for unintended pregnancy AND sexually transmissible infections (STIs). Amari checks to make sure the condom has not expired, and that the condom package isn’t opened or torn.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneA,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Safe sex means always using a condom or dam for any sexual activity involving vaginal, anal or oral sex. These barrier methods of protection minimise the amount of skin-to-skin contact and stop the transfer of bodily fluids.</p><p>Visit <a href='https://bodytalk.org.au/keeping-an-eye-on-stis/your-best-defence/' target='_blank'>Body Talk</a> for information.</p>"
        },
        nextStepId: 'sex-1a-1-2',
      },
      {
        id: 'sex-1a-1-2',
        type: 'question',
        text: "<p>After unwrapping the condom, Jamie checks in with Amari just to be sure they’re still up for sex. Amari cuddles up to Jamie, smiles and nods… Afterwards, snuggling up, Amari says:</p>",
        backgroundImage: SvgSexOneA,
        options: [
          {
            id: 'sex-1a-1-2-option-1',
            text: '“Wow! I feel so close to you. How was it for you?” Jamie smiles. After talking about it for a while, Jamie says, “we should really look into getting more condoms.”',
            icon: '😉',
            iconBackground: '#fbe9b6',
            nextStepId: 'sex-1a-1-learnmore'
          },
          {
            id: 'sex-1a-1-2-option-2',
            text: '“Wow! That was amazing. How was it for you?” Jamie smiles. After talking for a while, Amari says, “I don’t mind using condoms. But since you have ‘the rod’, maybe we should talk about what to do if we want to stop using them eventually.”',
            icon: '➖',
            iconBackground:'#c9e9ff',
            nextStepId: 'sex-1a-2-learnmore',
    
          }
        ]
      },
      {
        id: 'sex-1a-1-learnmore',
        type: 'learnmore',
        text: '<p>Amari and Jamie both enjoyed themselves and were up for talking about the experience. Some things they might have discussed include what they liked and what they didn’t, and what they might want to do differently next time. It can sometimes feel awkward, but communication is a key part of building and maintaining <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">a respectful, healthy relationship.</a></p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage:SvgSexOneA ,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Condoms are available in supermarkets, servos, pharmacies/chemists, and online stores. But did you know that you can get condoms for free at Family Planning NSW and sexual health clinics?  Family Planning NSW’s Freedom Condom project is a friendly, confidential way for young people to access free condoms, lube and sexual health information. Visit <a href='https://www.freedomcondom.org.au/' target='_blank'>https://www.freedomcondom.org.au</a> for more information. </p>"
        },
        nextStepId: null,
      },
      {
        id: 'sex-1a-2-learnmore',
        type: 'learnmore',
        text: '<p>Amari and Jamie both enjoyed themselves and were up for talking about the experience. It can sometimes feel awkward, but communication is a key part of building and maintaining <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">a respectful, healthy relationship.</a></p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneA ,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Condoms offer the best protection from STIs. If you are in a monogamous relationship, you may decide you don’t want to use condoms anymore. If you do, it’s important to get a sexual health check before doing so.</p><p>Visit <a href='https://bodytalk.org.au/keeping-an-eye-on-stis/sexual-health-checks/' target='_blank'>Body Talk</a> for more information on Sexual Health Checks</p>"
        },
        nextStepId: 'sex-1a-end',
      },
      {
        id: 'sex-1a-end',
        type: 'learnmore',
        text: '<p>A couple of days later, Amari and Jamie book in for a sexual health check at Family Planning NSW to discuss their sexual health and get STI tests.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneA,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Sexual health checks can be done at:</p><p>- Sexual health clinic<br>- Family Planning NSW<br>- Your doctor or local General Practitioner (GP)<br></p><p>Click <a href='https://bodytalk.org.au/keeping-an-eye-on-stis/sexual-health-checks/' target='blank'>here</a> for more information sexual health checks </p>"
        },
        nextStepId: null,
      },
      {
        id: 'sex-1b-learnmore',
        type: 'learnmore',
        text: "<p>Amari is putting pressure on Jamie and trying to make them have sex without a condom. This is not OK - it could actually be considered sexual coercion. People have the right to ask their partners to wear a condom, and to say no to sex if they won't use condoms.</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneBLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Sometimes, a person might try to manipulate another person’s emotions in order to get them to do something they don’t want to do. It can feel hard in the moment to maintain boundaries.</p><p>Condoms are essential part of sexual health. They are the only form of contraceptive that can protect against unintended pregnancy AND STIs. If your partner doesn’t want to wear one: </p><p>- You can say something like “we can either use a condom or not have sex. It’s up to you”</p><p>- You can explain why it’s important to you</p> <p>- You could also try, “It might feel better now, but it’ll feel a lot worse later if we get an STI”</p>"
        },
        nextStepId: 'sex-1b-1-2',
      },
      {
        id: 'sex-1b-1-2',
        type: 'question',
        text: "<p>Jamie says:</p>",
        backgroundImage:  SvgSexOneBLearnMore,
        options: [
          {
            id: 'sex-1b-1-2-option-1',
            text: 'I really want to have sex with you. But I’m not willing to have sex without protection. We can either use one and have sex tonight or wait until we get a sexual health check. We might not have to worry about pregnancy but STIs are another story.',
            icon: '😯',
            iconBackground: '#fbe9b6',
            nextStepId: 'sex-1b-1-2-learnmore'
          },
          {
            id: 'sex-1b-1-2-option-2',
            text: 'Really? I can’t believe you said that. Sex with a condom feels a lot better than no sex at all. And I’m not willing to go without one. That’s a deal breaker for me.',
            icon: '🤨',
            iconBackground:'#fbe9b6',
            nextStepId: 'sex-1b-1-2-learnmore',
    
          }
        ]
      },

      {
        id: 'sex-1b-1-2-learnmore',
        type: 'learnmore',
        text: '<p>There are many ways to communicate your boundaries to your partner. Talking about sex can feel awkward, but it’s an important part of a respectful relationship.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexOneBLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>A respectful relationship is one of mutual respect, trust, good communication, understanding and honesty. It's also important to respect yourself and think about what's best for you.</p><p>Being in a relationship should be a positive experience for both people. We each have the right to feel safe, valued and cared about in our relationships.</p><p>If you have tried discussing an issue with your partner and they are not being understanding or respectful of your point of view, you may need to remove yourself from the situation – and you may need to decide if this is the sort of relationship you want to be in. It’s also important to respect yourself and take care of what’s best for you.</p><p>Visit Body Talk for more information on <a href='https://bodytalk.org.au/relationships/respectful-relationships' target='_blank'>respectful relationships</a> and <a href='https://bodytalk.org.au/relationships/feeling-safe' target='_blank'>feeling safe.</a></p>"
        },
        nextStepId: 'sex-1b-end',
      },


      {
        id: 'sex-1b-end',
        type: 'learnmore',
        text: '<p>After continuing the conversation, Amari agrees to use a condom. Amari respects Jamie and does not want to jeopardise their relationship. If in the future they would like to stop using condoms, they should talk about it.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage: SvgSexOneA,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>If you are in a monogamous relationship, you may decide you don’t want to use condoms anymore. If you do, it’s important to get a sexual health check before doing so. Visit Body Talk for more information on <a href='https://bodytalk.org.au/keeping-an-eye-on-stis/sexual-health-checks' target='_blank'>sexual health checks</a> </p>"
        },
        nextStepId: null,
      },

]


export default sexOne